import cx from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const RadioButton = ({ icon, onClick, selected, label, className }) => {
  return (
    <button
      onClick={onClick}
      className={cx(
        'flex-1 py-4 px-4 rounded-lg h-[88px] border-2 bg-white transition-all border-solid cursor-pointer w-full',
        {
          'border-cauze-primary': selected,
          'border-lightgray-c4c hover:border-lightgray-999': !selected,
          [className]: Boolean(className),
        },
      )}
    >
      {Boolean(icon) && (
        <FontAwesomeIcon
          icon={icon}
          size="2x"
          className={`w-6 h-6 mx-auto mb-2 ${
            selected ? 'text-cauze-primary' : 'text-gray-595'
          }`}
        />
      )}
      <div
        className={
          selected
            ? 'text-cauze-primary font-agenda-medium'
            : 'text-gray-595 font-agenda'
        }
      >
        {label}
      </div>
    </button>
  );
};

const GiftingSection = ({ children, title, subtitle }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-lightgray-e8e overflow-hidden mb-8">
      <div className="bg-cauze-primary px-6 py-8 text-white">
        <h3 className="font-agenda-bold text-2xl mb-2">{title}</h3>
        <p className="text-white">{subtitle}</p>
      </div>

      <div className="p-6 space-y-6">{children}</div>
    </div>
  );
};

export { RadioButton, GiftingSection };
